import { Snackbar } from '@material-ui/core';
import { Alert } from '@material-ui/lab';
import React, { useState } from 'react';

export const AlertMessage = ({ 
    message, 
    duration = 8000, 
    type='error'
}: { 
    message: string; 
    duration?: number; 
    type?: 'success' | 'info' | 'warning' | 'error' 
}) => {
    const [isOpen, setIsOpen] = useState(true);

    return (
        <Snackbar
            open={isOpen}
            autoHideDuration={duration}
            onClose={() => setIsOpen(false)}
            anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
        >
            <Alert onClose={() => setIsOpen(false)} severity={type}>
                {message}
            </Alert>
        </Snackbar>
    );
};